import { ApiMessage } from '@/api/api'

import lodash_uniqBy from 'lodash/uniqBy'
import lodash_cloneDeep from 'lodash/cloneDeep'

const getDefaultState = () => {
    return {
        message: '',
        messages: [],
        triggerScrollDown: false,
        uploadFileList: [],
        typing: false
    }
}
// initial state
const state = getDefaultState()

const messageSend = (state, message) => {
    //console.log(message)
    if (!message.id) message.id = state.messages[state.messages.length - 1]?.id + 1

    if (message.isPolling) {
        messagePollingAdd(state, message)
    } else {
        message.time = new Date().getTime() / 1000
        state.messages.push(message)
    }

    state.triggerScrollDown = true
    setTimeout(() => {
        state.triggerScrollDown = false
    }, 5)
}

const messagePollingAdd = (state, messagePolling) => {
    //console.log(message)

    let incomingMessages = lodash_cloneDeep(state.messages)
    let findPrevIndex = 0
    if (incomingMessages.length) {
        incomingMessages.forEach((item, index) => {
            if (item.id < messagePolling.id) findPrevIndex = index
        })

        window.incomingMessages = incomingMessages

        messagePolling.time = incomingMessages[findPrevIndex].time + 1
    } else {
        findPrevIndex = -1
    }

    //let cloneMessage = lodash_cloneDeep(state.messages)
    state.messages.splice(findPrevIndex + 1, 0, messagePolling)
    //state.messages = cloneMessage
    //console.log('state.messages.splice',cloneMessage);
    // ищем предыдущее сообщение
}

export default {
    namespaced: true,
    state,
    mutations: {
        resetState(state) {
            Object.assign(state, getDefaultState())
        },
        setUploadFileListPush(state, item) {
            state.uploadFileList.push(item)
        },
        setTyping(state, boolean) {
            state.typing = boolean
        },
        setUploadFileListSplice(state, index) {
            state.uploadFileList.splice(index, 1)
        },
        setUploadFileListClear(state) {
            state.uploadFileList = []
        },
        messageIdFrontSyncBack(state, { idFrontSyncBack, message_id }) {
            let findIndex = state.messages.findIndex(
                item => item.idFrontSyncBack === idFrontSyncBack
            )

            if (findIndex !== -1) {
                let message = state.messages[findIndex]
                message.id = message_id

                this._vm.$set(state.messages, findIndex, message)
            }
        },
        messagesuUnshift(state, val) {
            state.messages.unshift(...val)
            //state.messages.push(state.messagesTemp)
        },
        messagesPush(state, val) {
            state.messages.push(...val)
            //state.messages.push(state.messagesTemp)
        },
        messagePrint(state, message) {
            state.message = message
        },
        messageSendNoTabSync(state, val) {
            messageSend(state, val)
        },
        messageSend(state, val) {
            messageSend(state, val)
        },
        messageAction(state, { name }) {
            state.messages.push({
                time: new Date().getTime() / 1000,
                actionName: name
            })

            state.triggerScrollDown = true
            setTimeout(() => {
                state.triggerScrollDown = false
            }, 5)
        }
    },
    actions: {},
    getters: {
        isFirstMessageClient: state => {
            return state.messages.find(item => item.from_role_id === 8)
        },
        getMessages: state => {
            //return state.messages
            return lodash_uniqBy(state.messages, 'id')
        }
    }
}
